/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { createEnum, EnumSet } from '@gh/core-data';

export const HousePlanStyle = createEnum('HOUSE_PLAN_STYLE', {
  LowSet: 1,
  HighSet: 2,
});

export type HousePlanStyle = EnumSet<typeof HousePlanStyle>;
